var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietaryGf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#585C60",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.014 15.932V16.604C17.014 19.278 15.082 21.182 12.212 21.182C9.16 21.182 6.99 18.914 6.99 16.1C6.99 13.286 9.188 11.018 12.128 11.018C13.99 11.018 15.572 11.956 16.398 13.342L15.012 14.14C14.508 13.23 13.416 12.586 12.128 12.586C10.056 12.586 8.6 14.112 8.6 16.114C8.6 18.088 10.028 19.614 12.226 19.614C14.004 19.614 15.096 18.69 15.39 17.374H12.114V15.932H17.014ZM24.5259 12.74H20.3959V15.484H24.3859V17.024H20.3959V21H18.7859V11.2H24.5259V12.74Z",
    fill: "#585C60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietaryGf);
export default __webpack_public_path__ + "static/media/dietary-gf.31c03bd600dd94972cc583e13165e57b.svg";
export { ForwardRef as ReactComponent };